import { useEffect, useRef } from 'react'

import { Primitive } from '@sentry/core'

import { captureException } from '~/utils/errors'

const DEFAULT_TIMEOUT_MS = 20_000

export const useStuckLoadingDetection = (
  component: string,
  isLoading: boolean,
  context?: {
    timeoutMs?: number
    tags?: Record<string, Primitive>
    extra?: Record<string, unknown>
  },
) => {
  const hasReportedRef = useRef(false)
  const timeoutMs = context?.timeoutMs ?? DEFAULT_TIMEOUT_MS

  useEffect(() => {
    if (!isLoading) {
      hasReportedRef.current = false
      return
    }
    if (hasReportedRef.current) return

    const timeout = setTimeout(() => {
      hasReportedRef.current = true
      captureException(
        new Error(
          `${component}: loading indicator stuck for ${timeoutMs / 1000}s`,
        ),
        {
          tags: { component, ...context?.tags },
          extra: context?.extra,
        },
      )
    }, timeoutMs)

    return () => clearTimeout(timeout)
  })
}
